import styled from 'styled-components'
import Color from 'color'
import type { ButtonCircleProps } from './BtnCircleV2'

export const StyledButton = styled.button<ButtonCircleProps>`
  border: none;
  appearance: none;
  outline: none;
  user-select: none;

  &:focus {
    outline: none;
  }

  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: 0.3s;
  background-color: transparent;

  &:active {
    transition: 0s;
  }

  ${({ size }) => {
    switch (size) {
      case 'large':
        return `
          width: 40px;
          height: 40px;
        `
      case 'medium':
        return `
          width: 32px;
          height: 32px;
        `
      case 'small':
        return `
          width: 24px;
          height: 24px;
        `
    }
  }}

  ${({ theme, fill, color }) => {
    let btnColor = theme.colors.primary
    let btnColorActiveFilled = Color(btnColor).lighten(0.12).hex()
    let btnColorActiveOutlined = Color(btnColor).lighten(0.88).hex()

    switch (true) {
      case fill === 'filled' && color === 'onPrimary':
        return `
          color: ${theme.colors.white};
          background-color: ${btnColor};
          &:active {
            background-color: ${btnColorActiveFilled};
          }
        `
      case fill === 'filled' && color === 'onWhite':
        return `
          color: ${btnColor};
          box-shadow: 0 0 0 1px ${theme.colors.textAndBackgroundWhiteGrey};

          &:active {
            background-color: ${theme.colors.textAndBackgroundWhiteGrey};
          }
        `
      case fill === 'outlined' && color === 'monochrome':
        return `
          color: ${theme.colors.textAndBackgroundDark};
          box-shadow: 0 0 0 1px ${theme.colors.textAndBackgroundLightGrey};

          &:active {
            background-color: ${theme.colors.textAndBackgroundWhiteGrey};
          }
        `
      case fill === 'outlined' && color === 'primary':
        return `
          color: ${btnColor};
          box-shadow: 0 0 0 1px ${btnColor};

          &:active {
            background-color: ${btnColorActiveOutlined};
          }
        `
      case fill === 'empty' && color === 'primary':
        return `
          color: ${btnColor};

          &:active {
            background-color: ${btnColorActiveOutlined};
          }
        `
    }
  }}

  ${({ disabled, theme }) =>
    disabled &&
    `
    color: ${theme.colors.textAndBackgroundGrey} !important;
    box-shadow: none !important;
    background-color: ${theme.colors.textAndBackgroundWhiteGrey} !important;
  `}
`
